module.exports = __webpack_public_path__ + "assets/media/morning.a431d967.mp3";